export const PagePrefixes = {
    SEARCH: 'search',
    HOMEPAGE: 'hp',
    SPECIAL_PAGE: 'sp',
    PRODUCT_LISTING_PAGE: 'plp',
};
